const { loadBranding } = require("utils/branding");

(async () => {
  const branding = await loadBranding();
  if (branding?.assetPath) {
    __webpack_public_path__ = branding.assetPath;
  }
})();
